import { type CyclesSettings, MAX_BOTS, ROUND_OPTIONS, type RoundCount } from '@xox/shared'
import { Segmented } from '../components/ui'

interface Props {
  value: CyclesSettings
  onChange: (patch: Partial<CyclesSettings>) => void
  disabled?: boolean
  /** Light-on-dark styling for the lobby card. */
  tone?: 'light' | 'dark'
}

const ROUNDS = ROUND_OPTIONS.map((n) => ({ value: String(n) as `${RoundCount}`, label: String(n) }))
const BOTS = Array.from({ length: MAX_BOTS + 1 }, (_, n) => ({
  value: String(n) as '0' | '1' | '2' | '3',
  label: n === 0 ? 'None' : String(n),
}))

/** Rounds per match and how many GRID bots fill the empty slots; one control for panel and lobby. */
export function CyclesSettingsFields({ value, onChange, disabled = false, tone = 'light' }: Props) {
  return (
    <div className={`flex flex-col gap-2 ${disabled ? 'pointer-events-none opacity-70' : ''}`}>
      <div className="flex items-center justify-between gap-3 text-sm">
        <span className="font-medium">Rounds</span>
        <Segmented
          label="Rounds per match"
          value={String(value.rounds) as `${RoundCount}`}
          options={ROUNDS}
          onChange={(v) => onChange({ rounds: Number(v) as RoundCount })}
          tone={tone}
        />
      </div>
      <div className="flex items-center justify-between gap-3 text-sm">
        <span className="font-medium">Bots</span>
        <Segmented
          label="Bots"
          value={String(value.bots) as '0' | '1' | '2' | '3'}
          options={BOTS}
          onChange={(v) => onChange({ bots: Number(v) })}
          tone={tone}
        />
      </div>
    </div>
  )
}
